<template>
  <div class="cascadeMatterChecker">
    <rich-radio-group>
      <div v-for="(item, index) in options" :key="index">
        <rich-radio :option="item" v-model="data" @input="dataChange" />
        <span
        class="check-required"
        v-show="data === item.value"
        >*</span>
        <rich-input
          v-if="data === item.value"
          v-model="remark[item.value]"
          :maxlength="300"
          @blur="remarkChange"
          :placeholder="gettext('请输入')"
        />
        <div class="error-msg" v-if="showErr && data === item.value" v-text="errmsg"></div>
      </div>
    </rich-radio-group>
    <div
      class="error-msg"
      v-if="showErr && !data"
      v-text="errmsg"
    ></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: '',
      remark: {},
      showErr: false,
      errmsg: this.gettext('选项和输入框不能为空'),
      errmsgs: {}
    }
  },
  props: {
    options: {},
    result: {}
  },
  methods: {
    dataChange () {
      this.change()
    },

    remarkChange () {
      this.change()
    },

    getValue () {
      return {
        result: this.result,
        matter: this.data,
        remark: this.remark[this.data]
      }
    },

    change () {
      this.$emit('input', this.getValue())
    },
    validate (cb) {
      let value = this.getValue()
      let pass = true
      let msg = ''
      this.errmsgs = {}
      if (!value.matter || !value.remark) {
        pass = false
      }
      this.errmsg = msg || this.gettext('选项和输入框不能为空')
      this.showErr = !pass
      cb && pass && cb(pass)
      return pass
    }
  }
}
</script>

<style lang="scss" scoped>
.error-msg {
  margin-top: 3px;
  font-size: 24px;
  color: #e64340;
}
.check-required {
  position: relative;
  top: 54Px;
  z-index: 1;
  color: #e64340
}
</style>
